// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_1lxsJ","tips":"_1FyPb","btns":"_2tYg7"};